<template>
  <AppModal
    ref="modalRef"
    model-value
    class="z-max"
    body-class="col full-width border-bottom flex items-center"
    footer-class="q-pa-lg flex items-center border-top full-width"
    position="right"
    show-close-btn
    :title="$t('text.successful')"
    @hide="$emit('hide')"
  >
    <div class="q-pa-lg text-center col">
      <q-icon
        class="q-mb-md"
        name="img:/circle-check.svg"
        size="80px"
      />
      <div
        class="fs-16 text-weight-medium q-mb-md"
        v-html="$t('text.youHaveSubscribed')"
      />
      <div class="fs-14 text-grey-6">
        <span v-html="$t('text.youWillReceiveNews')" />
        <span class="color-primary q-ml-xs">{{ email }}</span>
      </div>
    </div>
  </AppModal>
</template>

<script setup>
import AppModal from 'components/AppModal.vue';
import { ref } from 'vue';

defineProps({
  email: {
    type: String,
    required: true,
  },
});

defineEmits(['hide']);

const modalRef = ref(null);
</script>

<style lang="scss" scoped>
.color-primary {
  color: var(--blog-primary-color, $primary);
}
</style>
